import { ComboStepConfig } from '../shared/combo-types'

export const ABUNDANCIA_CONSCIENTE_NAME = 'Abundancia Consciente'

export const ABUNDANCIA_CONSCIENTE_PREAMBLE = {
    firstStepIntro:
        'Es la primera parte de un camino de abundancia consciente (prosperidad y abundancia → liberación de bloqueo del dinero → conexión con tu yo futuro).',
    finalStepClosing:
        'cerrá el arco del combo mostrando cómo la lectura de abundancia, la liberación del bloqueo del dinero y el yo futuro en prosperidad forman un mismo camino de abundancia consciente.',
}

export const ABUNDANCIA_CONSCIENTE_STEPS: ComboStepConfig[] = [
    {
        step: 1,
        type: 'combo-abundancia-prosperidad',
        title: 'Tirada de Abundancia y Prosperidad',
        shortTitle: 'Abundancia y Prosperidad',
    },
    {
        step: 2,
        type: 'combo-abundancia-bloqueo',
        title: 'Tirada de Liberación de Bloqueo del Dinero',
        shortTitle: 'Liberación de Bloqueo del Dinero',
    },
    {
        step: 3,
        type: 'combo-abundancia-yo-futuro',
        title: 'Tirada de Conexión con tu Yo Futuro',
        shortTitle: 'Conexión con tu Yo Futuro',
    },
]

export const ABUNDANCIA_CONSCIENTE_TOTAL_STEPS = ABUNDANCIA_CONSCIENTE_STEPS.length
